import Vue from 'vue';
import CryptoJS from 'crypto-js';
export default {
  data() {
    return {
      roleId: '',
      userId: '',
      userFullName: '',
      searchFromDate: '',
      searchToDate: '',
      tempSearchFromDate: '',
      showSearchFromDate: false,
      tempSearchToDate: '',
      showSearchToDate: false,
      searchModal: false,
      userAllRoles: [],
      //row 1
      dispatchedMissions: '',
      allWorkingTime: '',
      canceledMissions: '',
      tempClosedMissions: '',
      //row 2
      dashboardIMG: require('@/assets/images/dashboard800Image.png'),
      dashboardSendAverge: null,
      dashboardFollowUpFinishCount: null,
      //pie rank
      pieRankChartOption: {
        colors: [],
        chart: {
          renderTo: 'dashboardQCPieRankChart',
          type: 'pie',
          height: '240px',
          redraw: true,
        },
        title: {
          text: '',
        },
        legend: {
          layout: 'vertical',
          useHTML: true,
          enabled: false,
          rtl: true,
          align: 'right',
          verticalAlign: 'middle',
          itemMarginTop: 3,
          itemMarginBottom: 3,
          itemStyle: {
            fontSize: '10px',
            direction: 'ltr',
            textAlign: 'left',
            width: '80px',
          },
        },
        series: [
          {
            name: '',
            keys: ['name', 'y', 'tooltipText'],
            colorByPoint: true,
            data: [],
            size: '100%',
            slicedOffset: 5,
            showInLegend: true,
            useHTML: true,
          },
        ],
        plotOptions: {
          pie: {
            innerSize: 90,
            depth: 50,
            dataLabels: {
              enabled: true,
              useHTML: true,
              style: {
                fontSize: '9px',
                textOutline: 'none',
                color: '#ffffff',
              },
            },
          },
          useHTML: true,
          series: {
            title: 'اولویت ها',
            cursor: 'pointer',
            borderRadius: 5,
            dataLabels: [
              {
                enabled: true,
                distance: 15,
                format: '{point.name}',
                style: {
                  fontSize: '9px',
                  textOutline: 'none',
                  color: '#ffffff',
                },
              },
              {
                enabled: true,
                distance: '-20%',
                format: '{point.y}',
                style: {
                  fontSize: '9px',
                  textOutline: 'none',
                  color: '#ffffff',
                },
              },
            ],
          },
        },
        tooltip: {
          useHTML: true,
          pointFormat:
            '<br/><div class="tooltipPointWrapper">‎' +
            '<span style="color:white">{point.tooltipText}</span>: <span  style="color:white">{point.y}</span></div><div class="tooltipPointWrapper">‎' +
            '<span style="color:white">درصد</span>: <span  style="color:white">{point.percentage:.2f}</span></div>',
        },
      },
      //pie call
      pieActionChartOption: {
        colors: [
          '#FF7600',
          '#007D83',
          '#002E91',
          '#D69415',
          '#C66512',
          '#0CC881',
          '#4986FF',
          '#FFB528',
          '#FF6925',
          '#02F4FF',
          '#1A63FF',
          '#FFA900',
        ],
        chart: {
          renderTo: 'dashboardQCPieCallChart',
          type: 'pie',
          height: '240px',
          redraw: true,
        },
        title: {
          text: '',
        },
        legend: {
          layout: 'vertical',
          useHTML: true,
          enabled: false,
          rtl: true,
          align: 'right',
          verticalAlign: 'middle',
          itemMarginTop: 3,
          itemMarginBottom: 3,
          itemStyle: {
            fontSize: '10px',
            direction: 'ltr',
            textAlign: 'left',
            width: '80px',
          },
        },
        series: [
          {
            name: '',
            keys: ['name', 'y', 'tooltipText'],
            colorByPoint: true,
            data: [],
            size: '100%',
            slicedOffset: 5,
            showInLegend: true,
            useHTML: true,
          },
        ],
        plotOptions: {
          pie: {
            innerSize: 0,
            depth: 0,
            dataLabels: {
              enabled: true,
              useHTML: true,
              style: {
                fontSize: '9px',
                textOutline: 'none',
                color: '#ffffff',
              },
            },
          },
          useHTML: true,
          series: {
            title: 'تماس',
            cursor: 'pointer',
            borderRadius: 5,
            dataLabels: [
              {
                enabled: true,
                distance: 15,
                format: '{point.name}',
                style: {
                  fontSize: '9px',
                  textOutline: 'none',
                  color: '#ffffff',
                },
              },
              {
                enabled: true,
                distance: '-20%',
                format: '{point.y}',
                style: {
                  fontSize: '9px',
                  textOutline: 'none',
                  color: '#ffffff',
                },
              },
            ],
          },
        },
        tooltip: {
          useHTML: true,
          pointFormat:
            '<br/><div class="tooltipPointWrapper">‎' +
            '<span style="color:white">{point.tooltipText}</span>: <span  style="color:white">{point.y}</span></div><div class="tooltipPointWrapper">‎' +
            '<span style="color:white">درصد</span>: <span  style="color:white">{point.percentage:.2f}</span></div>',
        },
      },
      //row 3
      loginLogoutTableHeader: [
        { text: 'تاریخ ورود', value: 'loginDate', align: 'start' },
        { text: 'تاریخ خروج', value: 'logoutDate', align: 'start' },
        { text: 'مدت زمان', value: 'duration', align: 'center' },
      ],
      loginLogoutTableItems: [],
      lackOfCodeMissions: null,
      addressConfirmationMissions: null,
      inboundCalls: null,
      outboundCalls: null,
      //row 4
      //line mission chart
      lineMissionChartOptions: {
        chart: {
          type: 'spline',
          height: '240px',
        },
        title: {
          text: '',
        },
        subtitle: {
          text: '',
        },
        xAxis: {
          categories: [],
        },
        legend: {
          enabled: false,
        },
        yAxis: {
          title: {
            text: '',
          },
          labels: {
            format: '{value}',
          },
        },
        tooltip: {
          useHTML: true,
          crosshairs: true,
          shared: true,
        },
        plotOptions: {
          spline: {
            marker: {
              radius: 4,
              lineColor: '#666666',
              lineWidth: 1,
            },
          },
        },
        series: [
          {
            name: 'ماموریت ها',
            marker: {
              symbol: 'diamond',
            },
            data: [],
          },
        ],
      },
      //row 5
      //line call chart
      callLineChart: {
        chart: {
          type: 'spline',
          height: '240px',
          zoomType: 'x',
          resetZoomButton: {
            position: {
              verticalAlign: 'top',
              align: 'left',
            },
          },
        },
        title: {
          text: '',
        },
        subtitle: {
          text: '',
        },
        xAxis: {
          type: 'datetime',
        },
        legend: {
          enabled: true,
          useHTML: true,
        },
        yAxis: {
          title: {
            text: '',
          },
          labels: {
            format: '{value}',
          },
        },
        tooltip: {
          useHTML: true,
          crosshairs: true,
          shared: true,
        },
        plotOptions: {
          spline: {
            marker: {
              radius: 4,
              lineColor: '#666666',
              lineWidth: 1,
            },
          },
        },
        series: [],
      },
    };
  },
  methods: {
    readyDashboard: function (data) {
      this.dispatchedMissions = data.dispatchedMissions ? data.dispatchedMissions.valueLong : '-';
      this.canceledMissions = data.canceledMissions ? data.canceledMissions.valueLong : '-';
      this.tempClosedMissions = data.tempClosedMissions ? data.tempClosedMissions.valueLong : '-';
      let duration1 = Math.round(data.workingHours.valueDouble);
      duration1 = duration1 * 1000;
      this.allWorkingTime = this.msToTime(duration1);
      //row2
      let duration2 = Math.round(data.dispatchAverageTime.valueLong);
      duration2 = duration2 * 1000;
      this.dashboardSendAverge = this.msToTime(duration2);
      this.dashboardFollowUpFinishCount = data.allowFollowUpMissions.valueLong;
      //pie rank chart
      let pieChartData = JSON.parse(JSON.stringify([]));
      let pieChartTempArray = JSON.parse(JSON.stringify([]));
      pieChartTempArray = JSON.parse(JSON.stringify(data.missionsByRank));
      for (let i = 0; i < pieChartTempArray.length; i++) {
        if (
          pieChartTempArray[i].title == 'سفید' &&
          !this.pieRankChartOption.colors.includes('#EBEBEB')
        ) {
          this.pieRankChartOption.colors.push('#EBEBEB');
        } else if (
          pieChartTempArray[i].title == 'سبز' &&
          !this.pieRankChartOption.colors.includes('#2EBA7F')
        ) {
          this.pieRankChartOption.colors.push('#2EBA7F');
        } else if (
          pieChartTempArray[i].title == 'زرد' &&
          !this.pieRankChartOption.colors.includes('#FFBD55')
        ) {
          this.pieRankChartOption.colors.push('#FFBD55');
        } else if (
          pieChartTempArray[i].title == 'قرمز' &&
          !this.pieRankChartOption.colors.includes('#DA6757')
        ) {
          this.pieRankChartOption.colors.push('#DA6757');
        }
        pieChartData.push({
          name: pieChartTempArray[i].title,
          y: pieChartTempArray[i].valueLong,
          tooltipText: 'تعداد',
        });
      }
      pieChartData = JSON.parse(JSON.stringify(pieChartData));
      this.pieRankChartOption.series[0].data = [];
      this.pieRankChartOption.series[0].data = pieChartData;
      //pie Call
      let pieChartData2 = JSON.parse(JSON.stringify([]));
      let pieChartTempArray2 = JSON.parse(JSON.stringify([]));
      pieChartTempArray2 = JSON.parse(JSON.stringify(data.actionsOnMissions));
      for (let i = 0; i < pieChartTempArray2.length; i++) {
        pieChartData2.push({
          name: pieChartTempArray2[i].title,
          y: pieChartTempArray2[i].valueLong,
          tooltipText: 'تعداد',
        });
      }
      pieChartData2 = JSON.parse(JSON.stringify(pieChartData2));
      this.pieActionChartOption.series[0].data = [];
      this.pieActionChartOption.series[0].data = pieChartData2;
      //row 3
      this.lackOfCodeMissions = data.lackOfCodeMissions ? data.lackOfCodeMissions.valueLong : '-';
      this.addressConfirmationMissions = data.addressConfirmationMissions
        ? data.addressConfirmationMissions.valueLong
        : '-';
      this.inboundCalls = data.inboundCalls ? data.inboundCalls.valueLong : '-';
      this.outboundCalls = data.outboundCalls ? data.outboundCalls.valueLong : '-';
      //row 4 cloumn
      if (data.missionsByDate.length > 0) {
        for (let i = 0; i < data.missionsByDate.length; i++) {
          let text = data.missionsByDate[i].title.split(' ');
          this.lineMissionChartOptions.xAxis.categories.push(text[1]);
          this.lineMissionChartOptions.series[0].data.push(data.missionsByDate[i].valueLong);
        }
      }
      //row 5
      if (data.callsByDateAndTag.length > 0) {
        let lineData = [];
        let times = [];
        let minute = Vue.moment(this.searchFromDate).format('mm');
        minute = Math.floor(minute / 30);
        minute = minute * 30;
        let startDate = Vue.moment(this.searchFromDate).format('yyyy-M-D HH');
        startDate = startDate + ':' + minute.toString();
        startDate = new Date(startDate).getTime();
        let finishDate = new Date(this.searchToDate).getTime();
        while (startDate <= finishDate) {
          let tempStartDate = new Date(startDate);
          times.push(tempStartDate);
          tempStartDate = Vue.moment(tempStartDate).add(30, 'm').toDate();
          startDate = new Date(tempStartDate).getTime();
        }
        for (let i = 0; i < data.callsByDateAndTag.length; i++) {
          lineData.push({ name: data.callsByDateAndTag[i].title, data: [] });
          for (let k = 0; k < times.length; k++) {
            let flag = false;
            for (let j = 0; j < data.callsByDateAndTag[i].subItems.length; j++) {
              let temp = new Date(times[k]).getTime();
              let temp2 = new Date(data.callsByDateAndTag[i].subItems[j].title).getTime();
              if (temp == temp2) {
                flag = true;
                let date2 = new Date(data.callsByDateAndTag[i].subItems[j].title.toString());
                let date3 = date2.toString();
                let splitForTime = date3.split(' ');
                let time = splitForTime[4];
                let splitedTime = time.split(':');
                let today = new Date(date2).toLocaleDateString('en-US', {
                  year: 'numeric',
                  month: '2-digit',
                  day: '2-digit',
                  formatMatcher: 'basic',
                });
                let sp = today.split('/');
                lineData[i].data.push([
                  Date.UTC(sp[2], sp[0] - 1, sp[1], splitedTime[0], splitedTime[1], '00'),
                  data.callsByDateAndTag[i].subItems[j].valueLong,
                ]);
              }
            }
            if (!flag) {
              let date2 = new Date(times[k].toString());
              let date3 = date2.toString();
              let splitForTime = date3.split(' ');
              let time = splitForTime[4];
              let splitedTime = time.split(':');
              let today = new Date(date2).toLocaleDateString('en-US', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                formatMatcher: 'basic',
              });
              let sp = today.split('/');
              lineData[i].data.push([
                Date.UTC(sp[2], sp[0] - 1, sp[1], splitedTime[0], splitedTime[1], '00'),
                0,
              ]);
            }
          }
        }
        this.callLineChart.series = lineData;
      }
    },
    readyLoginLogoutData: function (data) {
      this.loginLogoutTableItems = [];
      for (let i = 0; i < data.length; i++) {
        let loginDate = '-';
        let logoutDate = '-';
        let duration = Math.round(data[i].duration);
        duration = duration * 1000;
        if (data[i].loginDate) {
          loginDate = Vue.moment(data[i].loginDate).format('HH:mm:ss jYYYY/jM/jD');
        }
        if (data[i].logoutDate) {
          logoutDate = Vue.moment(data[i].logoutDate).format('HH:mm:ss jYYYY/jM/jD');
        }
        this.loginLogoutTableItems.push({
          loginDate: loginDate,
          logoutDate: logoutDate,
          duration: this.msToTime(duration),
        });
      }
    },
    pad: function (n, z) {
      z = z || 2;
      return ('00' + n).slice(-z);
    },
    msToTime: function (s) {
      let ms = s % 1000;
      s = (s - ms) / 1000;
      let secs = s % 60;
      s = (s - secs) / 60;
      let mins = s % 60;
      let hrs = (s - mins) / 60;
      return this.pad(hrs) + ':' + this.pad(mins) + ':' + this.pad(secs);
    },
    backToReport: function () {
      this.$router.push({ name: 'qcUsersForQCReport' });
    },
    dateTimeChange: function (type) {
      if (type == 'searchFromDate') {
        if (this.searchFromDate) {
          this.tempSearchFromDate = Vue.moment(this.searchFromDate).format(
            'HH:mm:ss jYYYY-jMM-jDD',
          );
        }
      } else if (type == 'searchToDate') {
        if (this.searchToDate) {
          this.tempSearchToDate = Vue.moment(this.searchToDate).format('HH:mm:ss jYYYY-jMM-jDD');
        }
      }
    },
    clearDateTime: function (type) {
      if (type == 'searchFromDate') {
        this.showSearchFromDate = false;
        this.searchFromDate = '';
        this.tempMoveFromStationTime = '';
      } else if (type == 'searchToDate') {
        this.showSearchToDate = false;
        this.searchToDate = '';
        this.tempSearchFromDate = '';
      }
    },
    showSearchModal: function () {
      this.getUserRoleList();
      this.searchModal = true;
    },
    search: function () {
      this.searchModal = false;
      this.getQCUser800DashboardFunction(this.searchFromDate, this.searchToDate, this.userId);
      this.getQCUsersLoginLogoutReportFunction(this.searchFromDate, this.searchToDate, this.userId);
    },
    cancelSearch: function () {
      this.searchModal = false;
    },
    showAllLoginLogout: function () {
      let roleId = this.roleId.toString();
      let encryptRoleId = CryptoJS.AES.encrypt(roleId, 'f9rr8Y2D96Klh87N').toString();
      let userId = this.userId.toString();
      let encryptUserId = CryptoJS.AES.encrypt(userId, 'f9rr8Y2D96Klh87N').toString();
      let id =
        encryptRoleId +
        '$$' +
        encryptUserId +
        '$$' +
        this.userFullName +
        '$$' +
        this.searchFromDate +
        '$$' +
        this.searchToDate;
      this.$router.push({ name: 'user115AllLoginLogout', params: { id: id } });
    },
  },
};
